import request from "@/service";

/* 人员列表 */
export function mqTreeUser(data) {
  return request({
    url: "/user/sys/dept/mqTreeUser",
    method: "get",
    params: data
  });
}

/* 资源名称查询 */
export function mqResourceList(data) {
  return request({
    url: "/user/mq/group/resourcePage",
    method: "get",
    params: data
  });
}

/* 存草稿 */
export function mqSave(data) {
  return request({
    url: "/user/mq/group/save",
    method: "post",
    data
  });
}

/* 预览消息 */
export function messagePreview(data) {
  return request({
    url: "/user/mq/group/previewQuery",
    method: "get",
    params: data
  });
}

/* 获取角色列表 */
export function getRoleList(data) {
  return request({
    url: "/user/sys/role/roleList",
    method: "get",
    params: data
  });
}

/* 发送消息 */
export function sendMQ(data) {
  return request({
    url: `/user/mq/group/sendMQ/${data}`,
    method: "get"
  });
}

/* 导入非系统用户名单 */
export function importUser(params) {
  return request({
    url: `/user/mq/group/import`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

export function importDingPhone(params) {
  return request({
    url: `/user/mq/group/importSimple`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

/* 中组部选调班 消息发送名单-qinzl */
export function getMqSendUserDraftList(data) {
  return request({
    url: "/user/mq/group/getMqSendUserDraftList",
    method: "post",
    data
  });
}
